module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      display: 'inline-block',
      'margin-right': _vm.getSpacing
    })
  }, [_c('svg', {
    attrs: {
      "width": _vm.getWidth,
      "height": _vm.getHeight
    },
    on: {
      "mousemove": _vm.mouseMoving,
      "click": _vm.selected
    }
  }, [_c('mask', {
    attrs: {
      "x": "0",
      "y": "0",
      "id": _vm.fillId
    }
  }, [_c('rect', {
    attrs: {
      "fill": "#fff",
      "width": _vm.getFill,
      "height": "100%",
      "x": _vm.getX
    }
  })]), _vm._v(" "), _c('image', {
    attrs: {
      "xlink:href": _vm.src,
      "mask": _vm.getFillId,
      "height": _vm.getHeight,
      "width": _vm.getWidth
    }
  }), _vm._v(" "), _c('image', {
    style: (_vm.getOpacity),
    attrs: {
      "xlink:href": _vm.src,
      "height": _vm.getHeight,
      "width": _vm.getWidth
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-c228006a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/raters/images/image.vue
// module id = 41
// module chunks = 0